export function normalizeReportContext(templateName, contextData) {
  if (templateName !== "conversation_list") return contextData;

  const conversation = contextData?.conversations_by_pk;
  if (!Array.isArray(conversation?.job_conversations)) return contextData;

  return {
    ...contextData,
    conversations_by_pk: {
      ...conversation,
      job_conversations: conversation.job_conversations.map((jobConversation) => ({
        ...jobConversation?.job,
        ...jobConversation
      }))
    }
  };
}
